export default [
	"Matthew",
	"Acts",
	"Psalms",
	"Ephesians",
	"Mark",
	"Luke",
	"John",
	"Romans",
	"1 Corinthians",
	"Genesis",
	"Exodus",
	"Ruth",
	"Leviticus",
	"Numbers",
	"Deuteronomy",
	"Joshua",
	"Judges",
	"1 Samuel",
	"2 Samuel",
	"1 Kings",
	"2 Kings",
	"1&2 Chronicles",
	"Ezra",
	"Nehemiah",
	"Esther",
	"Job",
	"Proverbs",
	"Ecclesiastes",
	"Song of Solomon",
	"Isaiah",
	"Jeremiah",
	"Lamentations",
	"Ezekiel",
	"Daniel",
	"Hosea",
	"Joel",
	"Amos",
	"Obadiah",
	"Jonah",
	"Micah",
	"Nahum",
	"Habakkuk",
	"Zephaniah",
	"Haggai",
	"Zechariah",
	"Malachi",
	"2 Corinthians",
	"Galatians",
	"Philippians",
	"Colossians",
	"1 Thessalonians",
	"2 Thessalonians",
	"1 Timothy",
	"2 Timothy",
	"Titus",
	"Philemon",
	"Hebrews",
	"James",
	"1 Peter",
	"2 Peter",
	"1 John",
	"2 John",
	"3 John",
	"Jude",
	"Revelation",
];
